import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";
import { floatingIndexList } from "constants/floatingIndexes";
import { floatingIndices } from "components/Admin/Cashflows/configItemValues";
import { setLoanAssumptionDefaults, shouldShowFixedIndex, shouldShowFloatingIndex, shouldShowIoPeriods } from "../deal-settings-rows-logic";

export const rows = {
  title: {
    label: "Underwriting Assumptions",
    isTitle: true
  },

  dateOfAction: {
    label: "Date Of Action",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.DATE, name: "loanProceedAssumptions[0].dateOfAction", variant: "filled" }
    ]
  },
  action: {
    label: "Action Taken",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "action",
        name: "loanProceedAssumptions[0].action",
        variant: "filled",
        options: [
          { name: "Refinance", id: "refi" },
          { name: "Sell", id: "sell" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  loanType: {
    label: "Loan Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "action",
        name: "loanProceedAssumptions[0].loanType",
        variant: "filled",
        parentId: "loanTypes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: (value, formik) => {
          setLoanAssumptionDefaults(value, formik);
        }
      }
    ]
  },
  term: {
    label: "Term (Months)",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.NUMBER, name: "loanProceedAssumptions[0].term", variant: "filled" }
    ]
  },
  amortization: {
    label: "Amortization Term (Months)",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.NUMBER, name: "loanProceedAssumptions[0].amortization", variant: "filled" }
    ]
  },
  loanSpread: {
    label: "Loan Spread",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.PERCENT, name: "loanProceedAssumptions[0].loanSpread", variant: "filled", decimals: 3 }
    ]
  },
  rateTypeId: {
    label: "Rate Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "action",
        name: "loanProceedAssumptions[0].rateTypeId",
        variant: "filled",
        parentId: "rateTypes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },
  fixedIndexes: {
    isVisible: data => shouldShowFixedIndex(data),
    label: "Index",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "action",
        name: "loanProceedAssumptions[0].indexId",
        variant: "filled",
        parentId: "fixedIndexes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },
  floatingIndexes: {
    isVisible: data => shouldShowFloatingIndex(data),
    label: "Index",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "action",
        name: "loanProceedAssumptions[0].indexId",
        variant: "filled",
        options: floatingIndexList
          .filter(({ name, value }) => (name !== "None" && value !== floatingIndices.Thirty_Day_Avg_SOFR))
          .map(({ name, label, value }) => ({ id: value, name, label, value })),
        displayWith: ({ name }) => name,
        setValueWith: ({ id }) => id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },
  minDSCR: {
    label: "Min DSCR",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.NUMBER, name: "loanProceedAssumptions[0].minDSCR", variant: "filled", decimals: 2 }
    ]
  },
  maxLTV: {
    label: "Max LTV",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.PERCENT, name: "loanProceedAssumptions[0].maxLTV", variant: "filled", decimals: 3 }
    ]
  },
  minDebtYield: {
    label: "Min Debt Yield",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.PERCENT, name: "loanProceedAssumptions[0].minDebtYield", variant: "filled", decimals: 3 }
    ]
  },
  UwRate: {
    label: "Underwritten Rate",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.PERCENT, name: "loanProceedAssumptions[0].UwRate", variant: "filled", decimals: 3 }
    ]
  }

};

export const generateCashflowEdit = data => ({
  title: {
    label: "Cashflow Assumptions",
    isTitle: true
  },
  amortizationType: {
    label: "Amortization Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "action",
        name: "loanProceedAssumptions[0].amortizationTypeId",
        variant: "filled",
        options: [
          { name: "Mortgage Style", id: "5ea9e68d-4680-11e9-82f6-0242ac120002" },
          { name: "Straight Line", id: "62d4a044-4680-11e9-82f6-0242ac120002" },
          { name: "Agency Floater", id: "65a393e5-4680-11e9-82f6-0242ac120002" },
          { name: "Interest Only", id: "68b0cd1f-4680-11e9-82f6-0242ac120002" },
          { name: "Straight Line Custom Amort", id: "d358209d-4680-11e9-82f6-0242ac120002" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },
  amortizationTerms: {
    label: "Amortization Terms",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.NUMBER, name: "loanProceedAssumptions[0].amortizationTerm", variant: "filled", decimals: 0 }
    ]
  },
  amortizationRate: {
    isVisible: data => shouldShowFloatingIndex(data),
    label: "Amortization Rate",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.PERCENT, name: "loanProceedAssumptions[0].amortizationRate", variant: "filled", decimals: 2 }
    ]
  },
  ioPeriods: {
    isVisible: data => shouldShowIoPeriods(data),
    label: "I/O Periods",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.NUMBER, name: "loanProceedAssumptions[0].interestOnlyPeriods", variant: "filled", decimals: 0 }
    ]
  },
  dayCount: {
    label: "DAYCOUNT",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "action",
        name: "loanProceedAssumptions[0].dayCountId",
        variant: "filled",
        options: [
          { name: "ACT/365", id: "27c630c3-766f-11e9-87b9-0242ac120002" },
          { name: "30/360", id: "41a7e0bb-fd1e-42b4-8c50-c5e44dc81372" },
          { name: "Act/Act", id: "6ed392ab-2f95-4186-a1ab-e3e4019051ed" },
          { name: "Act/360", id: "fb692b8f-766e-11e9-87b9-0242ac120002" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },
  closingCost: {
    label: "Closing Cost",
    cells: [
      { type: FORM_BUILDER_FIELD_TYPE.PERCENT, name: "loanProceedAssumptions[0].closingCosts", variant: "filled", decimals: 2 }
    ]
  }
});
